export const DEFAULT_PHOTO = 'img/icons8-picture.png';